import { createActionCreator } from '../../utils/helpers';

import { fundingReportMatches } from './types';

export const requestFundingReportMatches = createActionCreator(
  fundingReportMatches.request,
  'reportId',
);
export const requestFundingReportMatchesSuccess = createActionCreator(
  fundingReportMatches.success,
  'response',
);
export const requestFundingReportMatchesFailure = createActionCreator(
  fundingReportMatches.failure,
  'error',
);
